'use client';
import { useLanguage } from '@/contexts/LanguageContext';

export default function LogisticsSection() {
  const { t } = useLanguage();

  const cards = [
    { icon: '🚢', labelKey: 'logistics.card1' },
    { icon: '🌊', labelKey: 'logistics.card2' },
    { icon: '📋', labelKey: 'logistics.card3' },
    { icon: '🔄', labelKey: 'logistics.card4' },
  ];

  return (
    <section id="logistics" className="py-24 px-6 md:px-12 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 reveal">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-6">
            {t('logistics.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards?.map((card, index) => (
            <div
              key={index}
              className="reveal card-hover bg-card border border-border rounded-2xl p-8 text-center group"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="text-5xl mb-4">{card?.icon}</div>
              <p className="font-semibold text-foreground text-sm leading-snug">
                {t(card?.labelKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
